export default __webpack_public_path__ + "static/media/vendas.1078fee5.svg";